import { Converter } from '../types/converter';

// Import all converters
import { accelerationAngularConverter } from './accelerationAngular';
import { accelerationConverter } from './acceleration';
import { angleConverter } from './angle';
import { areaConverter } from './area';
import { caseConverter } from './case';
import { chargeConverter } from './charge';
import { concentrationMolarConverter } from './concentrationMolar';
import { concentrationSolutionConverter } from './concentrationSolution';
import { currencyConverter } from './currency';
import { currentConverter } from './current';
import { dataStorageConverter } from './dataStorage';
import { dataTransferConverter } from './dataTransfer';
import { densityConverter } from './density';
import { digitalImageResolutionConverter } from './digitalImageResolution';
import { electricConductanceConverter } from './electricConductance';
import { electricConductivityConverter } from './electricConductivity';
import { electricFieldStrengthConverter } from './electricFieldStrength';
import { electricPotentialConverter } from './electricPotential';
import { electricResistanceConverter } from './electricResistance';
import { electricResistivityConverter } from './electricResistivity';
import { electrostaticCapacitanceConverter } from './electrostaticCapacitance';
import { energyConverter } from './energy';
import { flowMassConverter } from './flowMass';
import { flowMolarConverter } from './flowMolar';
import { flowConverter } from './flow';
import { forceConverter } from './force';
import { frequencyWavelengthConverter } from './frequencyWavelength';
import { fuelConsumptionConverter } from './fuelConsumption';
import { fuelEfficiencyMassConverter } from './fuelEfficiencyMass';
import { fuelEfficiencyVolumeConverter } from './fuelEfficiencyVolume';
import { heatDensityConverter } from './heatDensity';
import { heatFluxDensityConverter } from './heatFluxDensity';
import { heatTransferCoefficientConverter } from './heatTransferCoefficient';
import { illuminationConverter } from './illumination';
import { inductanceConverter } from './inductance';
import { lengthConverter } from './length';
import { linearChargeDensityConverter } from './linearChargeDensity';
import { linearCurrentDensityConverter } from './linearCurrentDensity';
import { luminanceConverter } from './luminance';
import { luminousIntensityConverter } from './luminousIntensity';
import { magneticFieldStrengthConverter } from './magneticFieldStrength';
import { magneticFluxConverter } from './magneticFlux';
import { magneticFluxDensityConverter } from './magneticFluxDensity';
import { magnetomotiveForceConverter } from './magnetomotiveForce';
import { massFluxDensityConverter } from './massFluxDensity';
import { momentOfForceConverter } from './momentOfForce';
import { momentOfInertiaConverter } from './momentOfInertia';
import { numbersConverter } from './numbers';
import { permeabilityConverter } from './permeability';
import { powerConverter } from './power';
import { prefixesConverter } from './prefixes';
import { pressureConverter } from './pressure';
import { radiationConverter } from './radiation';
import { radiationAbsorbedDoseConverter } from './radiationAbsorbedDose';
import { radiationActivityConverter } from './radiationActivity';
import { radiationExposureConverter } from './radiationExposure';
import { soundConverter } from './sound';
import { specificHeatCapacityConverter } from './specificHeatCapacity';
import { specificVolumeConverter } from './specificVolume';
import { speedConverter } from './speed';
import { surfaceChargeDensityConverter } from './surfaceChargeDensity';
import { surfaceCurrentDensityConverter } from './surfaceCurrentDensity';
import { surfaceTensionConverter } from './surfaceTension';
import { temperatureConverter } from './temperature';
import { temperatureIntervalConverter } from './temperatureInterval';
import { thermalConductivityConverter } from './thermalConductivity';
import { thermalExpansionConverter } from './thermalExpansion';
import { thermalResistanceConverter } from './thermalResistance';
import { timeConverter } from './time';
import { torqueConverter } from './torque';
import { typographyConverter } from './typography';
import { velocityAngularConverter } from './velocityAngular';
import { viscosityDynamicConverter } from './viscosityDynamic';
import { viscosityKinematicConverter } from './viscosityKinematic';
import { volumeDryConverter } from './volumeDry';
import { volumeLumberConverter } from './volumeLumber';
import { volumeChargeDensityConverter } from './volumeChargeDensity';
import { volumeConverter } from './volume';
import { weightAndMassConverter } from './weightAndMass';

export const converters: Record<string, Converter> = {
  accelerationAngular: accelerationAngularConverter,
  acceleration: accelerationConverter,
  angle: angleConverter,
  area: areaConverter,
  case: caseConverter,
  charge: chargeConverter,
  concentrationMolar: concentrationMolarConverter,
  concentrationSolution: concentrationSolutionConverter,
  currency: currencyConverter,
  current: currentConverter,
  dataStorage: dataStorageConverter,
  dataTransfer: dataTransferConverter,
  density: densityConverter,
  digitalImageResolution: digitalImageResolutionConverter,
  electricConductance: electricConductanceConverter,
  electricConductivity: electricConductivityConverter,
  electricFieldStrength: electricFieldStrengthConverter,
  electricPotential: electricPotentialConverter,
  electricResistance: electricResistanceConverter,
  electricResistivity: electricResistivityConverter,
  electrostaticCapacitance: electrostaticCapacitanceConverter,
  energy: energyConverter,
  flowMass: flowMassConverter,
  flowMolar: flowMolarConverter,
  flow: flowConverter,
  force: forceConverter,
  frequencyWavelength: frequencyWavelengthConverter,
  fuelConsumption: fuelConsumptionConverter,
  fuelEfficiencyMass: fuelEfficiencyMassConverter,
  fuelEfficiencyVolume: fuelEfficiencyVolumeConverter,
  heatDensity: heatDensityConverter,
  heatFluxDensity: heatFluxDensityConverter,
  heatTransferCoefficient: heatTransferCoefficientConverter,
  illumination: illuminationConverter,
  inductance: inductanceConverter,
  length: lengthConverter,
  linearChargeDensity: linearChargeDensityConverter,
  linearCurrentDensity: linearCurrentDensityConverter,
  luminance: luminanceConverter,
  luminousIntensity: luminousIntensityConverter,
  magneticFieldStrength: magneticFieldStrengthConverter,
  magneticFlux: magneticFluxConverter,
  magneticFluxDensity: magneticFluxDensityConverter,
  magnetomotiveForce: magnetomotiveForceConverter,
  massFluxDensity: massFluxDensityConverter,
  momentOfForce: momentOfForceConverter,
  momentOfInertia: momentOfInertiaConverter,
  numbers: numbersConverter,
  permeability: permeabilityConverter,
  power: powerConverter,
  prefixes: prefixesConverter,
  pressure: pressureConverter,
  radiation: radiationConverter,
  radiationAbsorbedDose: radiationAbsorbedDoseConverter,
  radiationActivity: radiationActivityConverter,
  radiationExposure: radiationExposureConverter,
  sound: soundConverter,
  specificHeatCapacity: specificHeatCapacityConverter,
  specificVolume: specificVolumeConverter,
  speed: speedConverter,
  surfaceChargeDensity: surfaceChargeDensityConverter,
  surfaceCurrentDensity: surfaceCurrentDensityConverter,
  surfaceTension: surfaceTensionConverter,
  temperature: temperatureConverter,
  temperatureInterval: temperatureIntervalConverter,
  thermalConductivity: thermalConductivityConverter,
  thermalExpansion: thermalExpansionConverter,
  thermalResistance: thermalResistanceConverter,
  time: timeConverter,
  torque: torqueConverter,
  typography: typographyConverter,
  velocityAngular: velocityAngularConverter,
  viscosityDynamic: viscosityDynamicConverter,
  viscosityKinematic: viscosityKinematicConverter,
  volumeDry: volumeDryConverter,
  volumeLumber: volumeLumberConverter,
  volumeChargeDensity: volumeChargeDensityConverter,
  volume: volumeConverter,
  weightAndMass: weightAndMassConverter,
};
